import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getFrameworkAgreementCompanyCount = (frameworkAgreemenId, companytype) => {
  const queryString = qs.stringify({ companytype });
  return axios.get(
    `/api/framework_agreements/${frameworkAgreemenId}/companies/count?${queryString}`
  );
};

export const useFrameworkAgreementCompanyCount = (frameworkAgreementId, type, options = {}) => {
  return useQuery(
    `framework-agreement-${frameworkAgreementId}-${type}-count`,
    () => getFrameworkAgreementCompanyCount(frameworkAgreementId, type),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }
  );
}